import { withStyles } from '@material-ui/core';
import LinkButton from './LinkButton';
import styles from './LinkButton.styles';

export default withStyles(styles)(LinkButton);
